<div #prefixRef class="input-prefix">
  <ng-content select="[inputPrefix]"></ng-content>
</div>
<input #inputRef
       class="{{colorScheme?.main}}"
       maxlength="64"
       (focus)="onFocus(true)"
       (blur)="onFocus(false)"
       [type]="type"
       [style.padding-right]="showClearButton ? '32px' : '0'"
       [style.padding-left]="prefixRef?.children?.length ? '32px' : '0'"
       [matAutocomplete]="autocomplete"
       [matAutocompleteDisabled]="!autocomplete"
       [placeholder]="placeholder"
       [formControl]="inputControl">
<button *ngIf="inputControl.value?.length > 0 && showClearButton"
        mat-icon-button
        class="search-input__clear"
        (click)="resetValue()">
  <mat-icon>cancel</mat-icon>
</button>
